import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'HTKit/Icon';
import styles from './styles.scss';

const List = ({ steps = [], className = '', itemClassName = '' }) => {
  return Array.isArray(steps) && steps.length ? (
    <ul className={className}>
      {steps.map((bullet) => (
        <li key={bullet.id} className={cn(styles.listItem, itemClassName)}>
          <Icon name="checkmark-v2" className={cn('marginRight-tiny1', styles.listIcon)} />
          <p className="p1 n900">{bullet.description}</p>
        </li>
      ))}
    </ul>
  ) : null;
};

List.propTypes = {
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      description: PropTypes.string,
    }),
  ),
};

export default List;
